<template>
  <div class="virtual">
    <div class="bg-white q-mb-sm q-pa-md text-center countDown">
      <div class="title">{{ $t('waiting.virtual.title') }}</div>
      <div class="times">
        <CountDown :times="times" format="MMM:SS" @onEnd="handleEndCountdown" />
      </div>
    </div>
    <div class="bg-white q-mb-sm q-py-md q-px-lg details">
      <div>
        <div class="left">{{ $t('waiting.virtual.times') }}</div>
        <div>{{ details.times }}</div>
      </div>
      <div>
        <div class="left">{{ $t('waiting.virtual.price') }}</div>
        <div>
          <span>{{ $n(details.price, 'currency', 'id-ID') }}</span>
          <q-icon
            class="blue"
            name="font:dm-Duplicate"
            @click="copyTotalPrice(details.price)"
          />
        </div>
      </div>
      <div>
        <div class="left">{{ $t('waiting.virtual.icon') }}</div>
        <div class="icon">
          <img height="16px" :src="describeObj[details.types].icon" />
        </div>
      </div>
      <div>
        <div class="left">{{ $t('waiting.virtual.codes') }}</div>
        <div class="blue">
          <span>{{ details.codes }}</span>
          <q-icon
            name="font:dm-Duplicate"
            @click="copyOrderId(details.codes)"
          />
        </div>
      </div>
    </div>
    <div class="bg-white q-mb-sm q-py-md q-px-lg describe">
      <div class="title">{{ $t('waiting.virtual.tipsTitle') }}</div>
      <q-list
        v-for="(item, index) in describeObj[details.types].tips"
        :key="`${item.title}-${index}`"
      >
        <q-expansion-item :label="item.title">
          <q-card>
            <q-card-section>
              <ul>
                <li v-for="text in item.describe" :key="text">
                  <span v-html="text" />
                </li>
              </ul>
            </q-card-section>
          </q-card>
        </q-expansion-item>
        <q-separator
          v-if="index < describeObj[details.types].tips.length - 1"
        />
      </q-list>
    </div>
    <MButton :loading="checking" class="check-btn" @click="debounceCheck(true)">
      {{ $t('waiting.qrisCheckStatusText') }}
    </MButton>
  </div>
</template>

<script>
import IndexDialog from 'src/components/dialog/index.vue';
import CountDown from 'src/components/CountDown.vue';
import { copyToClipboard, debounce } from 'quasar';
import {
  getOrderInfo,
  reOrder,
  checkoutStatus,
  pullPaymentStatus,
} from 'src/api/order.js';
import { formatDate } from 'src/utils/base';
import MButton from 'src/components/MButton/index.vue';
import { closeDialogMixin, dialogQueue } from 'src/components/dialog';
import { getDescribe } from './units';
import { PAY_STATUS, showPayFailedDialog } from '../config';
import { showDialog } from '../../../utils/error_config';

export default {
  components: {
    CountDown,
    MButton,
  },
  mixins: [closeDialogMixin],
  data() {
    return {
      timer: null,
      times: 0,
      showTimeTip: false,
      details: {
        times: '',
        price: 0,
        types: 'SEAT',
        codes: '',
      },
      describeObj: {
        SEAT: {},
        BCA: {},
        BNI: {},
        BRI: {},
        PERMATA: {},
        MANDIRI: {},
      },
      debounceCheck: null,
      checking: false,
    };
  },
  created() {
    const currentId = this.$router.currentRoute.query.orderId;
    this.$store.dispatch('Menu/setOrderId', currentId.replace(/\d+_DM/, ''));
    this.handleGetOrderInfo();
    this.debounceCheck = debounce(this.handleGetOrderInfo, 400);
  },
  // 离开页面 清除定时器
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
  },
  methods: {
    // 查询订单信息
    handleGetOrderInfo(munual) {
      const payPrefId = this.detail?.payments?.[0]?.orderPaymentPreferenceId;
      const orderId = payPrefId
        ? `${payPrefId}_DM${this.orderId}`
        : this.orderId;
      const fn = munual ? pullPaymentStatus : checkoutStatus;
      if (munual) this.checking = true;
      fn({ orderId })
        .then((res) => {
          try {
            const { code, data } = res;
            if (code === 200) {
              this.detail = data?.orderDetail;
              this.times = this.times || data.expiredDate || 0;
              const time = data.orderDetail.createdTime.dbStamp;
              this.details.times = formatDate(time, 'EEEE, dd MMMM yyyy HH:mm');
              if (data.orderDetail.payments[0]) {
                this.details.types =
                  data.orderDetail.payments[0]?.paymentDisplayName?.replace(
                    '(Online)',
                    '',
                  ) || '';
                this.details.codes = data.orderDetail.payments[0].paymentCode;
              }
              this.details.price = data.orderDetail.grandTotal;
              this.describeObj = getDescribe(this, this.details.codes);
              // 支付失败
              if (data?.paymentStatus === 'FAILED') {
                if (data.paymentFailureReason === 'PAYMENT_TIMEOUT') {
                  // dialogQueue.push(
                  //   this.$q
                  //     .dialog({
                  //       component: MyDialog,
                  //       parent: this,
                  //       type: 'timeout',
                  //       cancel: this.$t('checkout.cancel'),
                  //       ok: this.$t('waiting.okBtn'),
                  //       title: this.$t('waiting.paymentTimeOutTitle'),
                  //     })
                  //     .onOk(() => {
                  //       this.onReOrder(this.orderId, this.detail);
                  //     })
                  //     .onCancel(() => {
                  //       this.noReOrder(this.orderId, this.detail);
                  //     }),
                  // );
                  showPayFailedDialog(this, data.paymentFailureReason);
                } else {
                  dialogQueue.push(
                    this.$q
                      .dialog({
                        component: IndexDialog,
                        customIcon:
                          'https://static.bakmigm.co.id/menu/dialog-icon/dialog_warn_icon.svg',
                        parent: this,
                        cancel: this.$t('checkout.cancel'),
                        ok: this.$t('waiting.okBtn'),
                        title: this.$t('waiting.paymentRejectedTitle'),
                      })
                      .onOk(() => {
                        this.onReOrder(this.orderId, this.detail);
                      })
                      .onCancel(() => {
                        this.noReOrder(this.orderId, this.detail);
                      }),
                  );
                }
                return;
              }
              // 支付成功
              if (data.paymentStatus === 'SUCCESS') {
                const storeUrl = this.$route.params.store;
                if (data?.orderDetail?.serviceType === 'FULL_DINE_IN') {
                  this.$router.push({ name: 'FullPaySuccess' });
                } else {
                  this.$router.push({
                    path: `/${storeUrl}/result/success`,
                    query: {
                      orderId: this.orderId,
                    },
                  });
                }
                return;
              }
              // 等待支付 每3秒轮询接口
              if (data.paymentStatus === 'PENDING') {
                this.timer = setTimeout(() => {
                  if (!munual) this.handleGetOrderInfo();
                }, 3000);
              }
              if (
                data.expiredDate &&
                data.expiredDate < 240 &&
                !this.showTimeTip &&
                data.paymentStatus === PAY_STATUS.PENDING
              ) {
                this.showTimeTip = true;
                return showPayFailedDialog(this, 'PAY_TIME_TIP');
              }
              if (data.paymentStatus === PAY_STATUS.PENDING && munual) {
                showPayFailedDialog(this, PAY_STATUS.PENDING);
              }
            } else {
              showDialog(this, code);
            }
          } catch (error) {
            console.log('ERR: ', error);
          }
        })
        .finally(() => {
          if (munual) {
            this.checking = false;
          }
        });
    },
    // 复原购物车
    onReOrder(orderId, detail) {
      if (detail?.serviceType === 'FULL_DINE_IN') {
        this.$router.replace({
          name: 'FullCheckout',
          query: { orderId },
        });
        return;
      }
      reOrder({ orderId }).then(() => {
        // 服务端数据有延迟，所以延迟一秒处理
        setTimeout(() => {
          this.$router.push({ name: 'checkout' });
        }, 1000);
      });
    },
    // 复原购物车 不跳转支付页
    noReOrder(orderId, detail) {
      if (detail?.serviceType === 'FULL_DINE_IN') {
        this.$router.push({ name: 'products-list' });
        return;
      }
      reOrder({ orderId }).then(() => {
        // 服务端数据有延迟，所以延迟一秒处理
        setTimeout(() => {
          this.$router.push({ name: 'products-list' });
        }, 1000);
      });
    },
    // 复制价格
    copyTotalPrice(text) {
      copyToClipboard(text)
        .then(() => {
          this.$q.notify({
            message: this.$t('waiting.virtual.copyPrice'),
            spinner: false,
            position: 'bottom',
            classes: 'glossy-bottom',
            type: 'ongoing',
            timeout: 1500,
          });
        })
        .catch(() => {
          // 失败
        });
    },
    // 复制订单号
    copyOrderId(text) {
      copyToClipboard(text)
        .then(() => {
          this.$q.notify({
            message: this.$t('waiting.virtual.copyOrder'),
            spinner: false,
            position: 'bottom',
            classes: 'glossy-bottom',
            type: 'ongoing',
            timeout: 1500,
          });
        })
        .catch(() => {
          // 失败
        });
    },
    // 超时回调
    handleEndCountdown() {},
  },
};
</script>

<style lang="scss">
.virtual {
  height: 100%;
  background: #f3f4f6;
  overflow: auto;
  padding-top: 64px;

  .countDown {
    .title {
      font-weight: bold;
      font-size: 12px;
      line-height: 120%;
      margin-bottom: 8px;
    }

    .times {
      font-weight: bold;
      font-size: 24px;
      line-height: 120%;
      color: #ff9e2d;
    }
  }

  .details {
    font-size: 12px;
    line-height: 16px;

    & > div {
      display: flex;
      justify-content: space-between;
      padding: 6px 0;

      .left {
        color: #6b7280;
      }

      .blue {
        color: #4a71d3;
        font-weight: bold;
      }

      .q-icon {
        vertical-align: text-bottom;
        margin-left: 4px;
        cursor: pointer;
      }
    }
  }

  .describe {
    .title {
      font-weight: bold;
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 12px;
    }

    .q-list {
      .q-item {
        padding: 0;

        .q-item__label {
          font-weight: bold;
          font-size: 12px;
          line-height: 16px;
        }
      }

      .q-card {
        .q-card__section {
          padding: 0;

          ul {
            padding-left: 20px;
          }
        }
      }

      .q-separator {
        margin: 0 -24px;
        background: #d1d5db;
      }
    }

    li {
      list-style-type: decimal;

      & > span {
        color: $dark;

        span {
          color: #4a71d3;
          font-weight: bold;
        }
      }
    }
  }

  .check-btn {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    bottom: 40px;
  }
}
</style>
